import {
  Datagrid,
  ExportButton,
  FunctionField,
  List,
  Pagination,
  SelectInput,
  TextInput,
  TopToolbar,
} from "react-admin";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { ListPageIndicator } from "../../components/TablePageIndicator";
import {
  ReviewedChip,
  reviewedFilterChoices,
} from "../../components/ReviewedChip";
import { csvExporter, simNao } from "../../components/csvExporter";
import {
  datagridSx,
  listCardWithToolbarSx,
  rowTitleSx,
} from "../../components/listStyles";

// O "Novo" do breadcrumb cobre a criação — o "Criar" da toolbar repetia
// a mesma ação
const ListActions = () => (
  <TopToolbar sx={{ alignItems: "center" }}>
    <ExportButton />
    <ListPageIndicator />
  </TopToolbar>
);

const filters = [
  <TextInput label="Buscar por nome" source="name" alwaysOn resettable />,
  <SelectInput
    source="reviewed"
    label="Revisão"
    alwaysOn
    emptyText="Todas"
    choices={reviewedFilterChoices}
    sx={{ minWidth: 180 }}
  />,
];

const exporter = csvExporter("instituicoes-de-ensino", {
  ID: (r) => r.id,
  Nome: (r) => r.name,
  Revisada: (r) => simNao(r.reviewed),
});

// Mesmo padrão da lista de Formações. sortable={false}: a API desta tela
// ignora a ordenação pedida e devolve sempre as revisadas primeiro.
export const EducationalInstitutionList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Instituições de Ensino"
        firstPath="/#/educational-institutions/crud"
        actionType="create"
      />
      <List
        filters={filters}
        actions={<ListActions />}
        exporter={exporter}
        perPage={25}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
        // Mantém a página atual visível enquanto a próxima carrega
        queryOptions={{ keepPreviousData: true }}
        sx={listCardWithToolbarSx}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={datagridSx}
        >
          <FunctionField
            label="Instituição"
            sortable={false}
            render={(record: any) => (
              <Typography component="span" sx={rowTitleSx}>
                {record.name}
              </Typography>
            )}
          />
          <FunctionField
            label="Revisão"
            sortable={false}
            render={(record: any) => (
              <ReviewedChip reviewed={record.reviewed} />
            )}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
